export function getJobList(isEmployee, inverse) {
    let { getJobListRequest, getJobListError, getJobListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_job_list',
        this.createBundle('get_job_list', { inverse }, this.GET, getJobListRequest, getJobListResult, getJobListError, isEmployee)
    )
}
